// Import Vue
import Vue from 'vue';

// Import Framework7
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';

// Import Framework7-Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';

// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.css';

import * as firebase from "firebase/app";
import 'firebase/database';
import 'firebase/functions';
import 'firebase/auth';

import moment from 'moment';
Vue.prototype.$moment=moment;

import { store } from '../store/store';

let forceProduction = false;

firebase.initializeApp({
  apiKey: "AIzaSyCXBEK9Im5wRvo4xkIJc2O3D6KgE2CVBuY",
  authDomain: "app.maskcount.com",
  databaseURL: ((process.env.NODE_ENV === 'production') || forceProduction )?"https://maskcount-2020.firebaseio.com":"https://maskcount-2020-dev.firebaseio.com",
  projectId: "maskcount-2020",
  storageBucket: "maskcount-2020.appspot.com",
  messagingSenderId: "412429105952",
  appId: "1:412429105952:web:78492830100e79e958f545",
  measurementId: "G-VK57D83HLE"
});
//firebase.functions().useFunctionsEmulator('http://localhost:5000');

Vue.prototype.$firebase = firebase;
// Import App Component
import App from '../components/app.vue';

// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue);

// Init App
new Vue({
  el: '#app',
  render: (h) => h(App),
  store,
  // Register App Component
  components: {
    app: App
  },
});